import { createFileRoute } from '@tanstack/react-router'
import { COLORS, FONTS, sectionInner } from '@/components/home/tokens'
import { PressReleaseView } from '@/components/press/PressReleaseView'
import { getLatestPressRelease } from '@/lib/pressReleases'

export const Route = createFileRoute('/press')({
  component: PressReleasePage,
})

function PressReleasePage() {
  const release = getLatestPressRelease()

  if (!release) {
    return (
      <section style={{ position: 'relative', zIndex: 10, padding: '200px 0 160px' }}>
        <div style={sectionInner}>
          <p style={{ fontFamily: FONTS.body, fontSize: 'var(--text-lg)', color: COLORS.neutral2 }}>
            No press releases yet.
          </p>
        </div>
      </section>
    )
  }

  return <PressReleaseView release={release} />
}
